module.exports = __webpack_public_path__ + "static/media/doodle.bd9b69db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/doodle.png
// module id = 1073
// module chunks = 0